import React from 'react';
import { Icon } from 'antd';

import '../styles/Component.css';


function RateViewer(props){

  const { prevValue, currValue, integerFontSize, decimalFontSize } = props;
  const rate = getRate(prevValue, currValue);
  const rateColor = getRateColor(rate);
  const rateValue = rate ? String(Math.abs(rate).toFixed(2)) : "--.--";

  return(
    <div className="rate-viewer-wrapper" style={{color: rateColor}}>
      {
        rate ? <Icon type={ rate > 0 ? 'arrow-up' : 'arrow-down'} style={{fontSize: integerFontSize}}/> : null
      }
      {
        rateValue.split('.').map((value, idx) =>
          <div key={idx} style={{fontSize : idx === 0 ? integerFontSize : decimalFontSize}}>
            {idx === 0 ? value+'.' : value}
          </div>
        )
      }
      <div style={{marginLeft:5}}>%</div>
    </div>
  )
}

function getRateColor (rate) {
  if(rate > 0) {
    return '#3dbd7d'
  }else if (rate === 0) {
    return '#828282'
  } else {
    return '#ff6060'
  }
}

/**
 * 두 숫자 사이의 증감률 반환하는 함수
 * @param {Number} prev
 * @param {Number} curr
 */
const getRate = (prev, curr) => {

  let rate = 0;

  if(prev && curr) {
    rate = (((curr - prev)/prev)*100).toFixed(2);
  } else {
    rate = 0;
  }

  return rate;
}

export default RateViewer;